export default __webpack_public_path__ + "static/media/about-1.d9c32103.png";